import {Button} from 'components/system/button';
import {LockIcon} from 'icons/lock';
import {useUpsell} from 'users';
import styles from './categories.module.css';

export const Categories = ({categories, config, onConfigChange}: Props) => {
  const {showUpsellModal} = useUpsell();

  // A category is considered selected if all of its tags are selected.
  const selectedCategories = categories.filter((category) =>
    category.question_tags.every((tag) => config.tags.includes(tag.name)),
  );

  return (
    <div className={styles.container}>
      {categories.map((category) => {
        // Is the current category selected?
        const selected = selectedCategories.includes(category);

        // Current category tag names,
        const categoryTags = category.question_tags.map((tag) => tag.name);

        // The tags to remove when unselecting this category.
        // This reduces to all of the category tags except any shared tags with another selected category.
        const tagsToRemove = selected
          ? categoryTags.filter((tag) =>
              selectedCategories.every(
                (selectedCategory) =>
                  selectedCategory === category ||
                  !selectedCategory.question_tags.map((tag) => tag.name).includes(tag),
              ),
            )
          : [];

        return (
          <Button
            key={category.id}
            color={selected ? 'orange' : 'greyLight'}
            type='fill'
            size='sm'
            icon={category.locked ? <LockIcon /> : null}
            onClick={() => {
              if (category.locked) {
                showUpsellModal({cta: 'question.locked'});
              } else {
                onConfigChange({
                  ...config,
                  tags: selected
                    ? config.tags.filter((tag) => !tagsToRemove.includes(tag))
                    : [...new Set([...config.tags, ...categoryTags])], // Trick for removing duplicates.
                });
              }
            }}>
            {category.name}
          </Button>
        );
      })}
    </div>
  );
};

type Props = {
  categories: QuestionCategory[];
  config: QuestionListConfig;
  onConfigChange: (config: QuestionListConfig) => void;
};
